<template>
  <v-bottom-sheet :hide-overlay="true" :persistent="true" v-model="show" inset scrollable>
    <div style="position:relative!important;overflow:auto;">
      <v-sheet>
        <v-btn
          style="z-index:20; position:absolute; top:0; right:0;"
          class="mt-1 mr-1"
          @click="
            () => {
              this['JobOrder/fetchJobOrders']({ page: this.page });
              $router.push('/joborder');
            }
          "
          color="error"
          dark
          icon
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-card class="elevation-0">
          <v-window v-model="windows" vertical>
            <v-window-item value="details">
              <v-list>
                <v-list-item two-line>
                  <v-list-item-content>
                    <v-list-item-title>Design Code</v-list-item-title>
                    <v-list-item-subtitle>{{ design_code }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item two-line>
                  <v-list-item-content>
                    <v-list-item-title>Item Category</v-list-item-title>
                    <v-list-item-subtitle>{{ jobOrder.category }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item two-line>
                  <v-list-item-content>
                    <v-list-item-title>Customer Name</v-list-item-title>
                    <v-list-item-subtitle>{{ jobOrder.customer.name }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item two-line>
                  <v-list-item-content>
                    <v-list-item-title>Karat of Gold</v-list-item-title>
                    <v-list-item-subtitle>{{ jobOrder.karat }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item
                  two-line
                  v-if="
                    jobOrder.category == 'Wedding rings' || jobOrder.category == 'Wedding Rings'
                  "
                >
                  <v-list-item-content>
                    <v-list-item-title>Engraving</v-list-item-title>
                    <v-list-item-subtitle>{{ jobOrder.engraving }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item
                  two-line
                  v-if="
                    jobOrder.category == 'Wedding rings' || jobOrder.category == 'Wedding Rings'
                  "
                >
                  <v-list-item-content>
                    <v-list-item-title>Groom</v-list-item-title>
                    <v-list-item-subtitle>{{ jobOrder.couple_name1 }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item two-line>
                  <v-list-item-content>
                    <v-list-item-title
                      >{{ is_wedding_ring() ? 'Groom ' : '' }}Size/s</v-list-item-title
                    >
                    <v-list-item-subtitle>{{ jobOrder.size }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item
                  two-line
                  v-if="
                    jobOrder.category == 'Wedding rings' || jobOrder.category == 'Wedding Rings'
                  "
                >
                  <v-list-item-content>
                    <v-list-item-title
                      >{{ is_wedding_ring() ? 'Groom ' : '' }}Width</v-list-item-title
                    >
                    <v-list-item-subtitle>{{ jobOrder.width }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item
                  two-line
                  v-if="
                    jobOrder.category == 'Wedding rings' || jobOrder.category == 'Wedding Rings'
                  "
                >
                  <v-list-item-content>
                    <v-list-item-title
                      >{{ is_wedding_ring() ? 'Groom ' : '' }}Thickness</v-list-item-title
                    >
                    <v-list-item-subtitle>{{ jobOrder.thickness }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item
                  two-line
                  v-if="
                    jobOrder.category == 'Wedding rings' || jobOrder.category == 'Wedding Rings'
                  "
                >
                  <v-list-item-content>
                    <v-list-item-title
                      >{{ is_wedding_ring() ? 'Groom ' : '' }}Weight of Gold</v-list-item-title
                    >
                    <v-list-item-subtitle>{{ jobOrder.weight }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item two-line>
                  <v-list-item-content>
                    <v-list-item-title
                      >{{ is_wedding_ring() ? 'Groom ' : '' }}Color of Gold</v-list-item-title
                    >
                    <v-list-item-subtitle>{{ jobOrder.color }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item two-line>
                  <v-list-item-content>
                    <v-list-item-title
                      >{{ is_wedding_ring() ? 'Groom ' : '' }}No. and Size of
                      Diamond</v-list-item-title
                    >
                    <v-list-item-subtitle>{{ jobOrder.no_of_diamond }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item
                  two-line
                  v-if="
                    jobOrder.category == 'Wedding rings' || jobOrder.category == 'Wedding Rings'
                  "
                >
                  <v-list-item-content>
                    <v-list-item-title>Bride</v-list-item-title>
                    <v-list-item-subtitle>{{ jobOrder.couple_name2 }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item
                  two-line
                  v-if="
                    jobOrder.category == 'Wedding rings' || jobOrder.category == 'Wedding Rings'
                  "
                >
                  <v-list-item-content>
                    <v-list-item-title>Bride Size</v-list-item-title>
                    <v-list-item-subtitle>{{ jobOrder.couple2_size }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item
                  two-line
                  v-if="
                    jobOrder.category == 'Wedding rings' || jobOrder.category == 'Wedding Rings'
                  "
                >
                  <v-list-item-content>
                    <v-list-item-title>Bride Width</v-list-item-title>
                    <v-list-item-subtitle>{{ jobOrder.couple2_width }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item
                  two-line
                  v-if="
                    jobOrder.category == 'Wedding rings' || jobOrder.category == 'Wedding Rings'
                  "
                >
                  <v-list-item-content>
                    <v-list-item-title>Bride Thickness</v-list-item-title>
                    <v-list-item-subtitle>{{ jobOrder.couple2_thickness }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item
                  two-line
                  v-if="
                    jobOrder.category == 'Wedding rings' || jobOrder.category == 'Wedding Rings'
                  "
                >
                  <v-list-item-content>
                    <v-list-item-title>Bride Weight of Gold</v-list-item-title>
                    <v-list-item-subtitle>{{ jobOrder.couple2_weight }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item
                  two-line
                  v-if="
                    jobOrder.category == 'Wedding rings' || jobOrder.category == 'Wedding Rings'
                  "
                >
                  <v-list-item-content>
                    <v-list-item-title>Bride Color of Gold</v-list-item-title>
                    <v-list-item-subtitle>{{ jobOrder.couple2_color }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item
                  two-line
                  v-if="
                    jobOrder.category == 'Wedding rings' || jobOrder.category == 'Wedding Rings'
                  "
                >
                  <v-list-item-content>
                    <v-list-item-title>Bride No. and Size of Diamond</v-list-item-title>
                    <v-list-item-subtitle>{{
                      jobOrder.couple2_no_of_diamond
                    }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item
                  two-line
                  v-if="
                    jobOrder.category == 'Pendants, earrings, and other accessories' ||
                      jobOrder.category == 'Pendants, Earrings, and Other Accessories'
                  "
                >
                  <v-list-item-content>
                    <v-list-item-title>Product Type</v-list-item-title>
                    <v-list-item-subtitle>{{ jobOrder.product_type.name }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item
                  two-line
                  v-if="
                    jobOrder.category == 'Engagement rings' ||
                      jobOrder.category == 'Engagement Rings' ||
                      jobOrder.category == 'Pendants, earrings, and other accessories' ||
                      jobOrder.category == 'Pendants, Earrings, and Other Accessories'
                  "
                >
                  <v-list-item-content>
                    <v-list-item-title>GIA</v-list-item-title>
                    <v-list-item-subtitle>{{ jobOrder.gia }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item two-line>
                  <v-list-item-content>
                    <v-list-item-title>Price</v-list-item-title>
                    <v-list-item-subtitle>{{
                      parseFloat(jobOrder.price).toLocaleString()
                    }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item two-line>
                  <v-list-item-content>
                    <v-list-item-title>Cost of Goods Sold</v-list-item-title>
                    <v-list-item-subtitle>{{
                      parseFloat(jobOrder.cogs).toLocaleString()
                    }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item two-line>
                  <v-list-item-content>
                    <v-list-item-title>Quantity</v-list-item-title>
                    <v-list-item-subtitle>{{ jobOrder.quantity }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item two-line>
                  <v-list-item-content>
                    <v-list-item-title>Attachments</v-list-item-title>
                    <v-dialog width="500" v-for="image in jobOrder.files" :key="image.id">
                      <template v-slot:activator="{ on }">
                        <v-img
                          :src="'/attachement/' + image.path"
                          max-height="50px"
                          max-width="50px"
                          v-on="on"
                        />
                      </template>
                      <v-img
                        :src="'/attachement/' + image.path"
                        max-height="500px"
                        max-width="500px"
                      />
                    </v-dialog>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item two-line>
                  <v-list-item-content>
                    <v-list-item-title>Amount Downpayment</v-list-item-title>
                    <v-list-item-subtitle>{{
                      parseFloat(jobOrder.deposit).toLocaleString()
                    }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item two-line>
                  <v-list-item-content>
                    <v-list-item-title>Amount Receivable/Balance</v-list-item-title>
                    <v-list-item-subtitle>{{
                      parseFloat(jobOrder.balance).toLocaleString()
                    }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item
                  two-line
                  v-if="
                    jobOrder.category == 'Wedding rings' || jobOrder.category == 'Wedding Rings'
                  "
                >
                  <v-list-item-content>
                    <v-list-item-title>Wedding Date</v-list-item-title>
                    <v-list-item-subtitle>{{ jobOrder.wedding_date }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item
                  two-line
                  v-if="
                    jobOrder.category == 'Wedding rings' || jobOrder.category == 'Wedding Rings'
                  "
                >
                  <v-list-item-content>
                    <v-list-item-title>Date Delivered from Factory</v-list-item-title>
                    <v-list-item-subtitle>{{
                      jobOrder.date_delivered_from_factory
                    }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item two-line>
                  <v-list-item-content>
                    <v-list-item-title>Date of Order</v-list-item-title>
                    <v-list-item-subtitle>{{ jobOrder.date_ordered }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item two-line>
                  <v-list-item-content>
                    <v-list-item-title>Date Picked Up/Purchased by Customer</v-list-item-title>
                    <v-list-item-subtitle>{{ jobOrder.date_pickup }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item two-line>
                  <v-list-item-content>
                    <v-list-item-title>Pick up Date</v-list-item-title>
                    <v-list-item-subtitle>{{ jobOrder.delivery_date }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item two-line>
                  <v-list-item-content>
                    <v-list-item-title>Rush Order</v-list-item-title>
                    <v-list-item-subtitle>{{ jobOrder.rush }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item two-line>
                  <v-list-item-content>
                    <v-list-item-title>Notes</v-list-item-title>
                    <v-list-item-subtitle>{{ jobOrder.notes }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-window-item>
            <v-window-item value="rawmaterial">
              <jobordershowrawmaterial :job_order_materials="job_order_materials" />
            </v-window-item>
            <v-window-item value="addrawmaterial">
              <joborderaddrawmaterial v-on:added="windows = 'rawmaterial'" />
            </v-window-item>
          </v-window>

          <v-card-actions>
            <v-chip class="mx-2" :disabled="windows === 'details'" @click="windows = 'details'">
              Details
            </v-chip>
            <v-chip
              class="mx-2"
              :disabled="windows === 'rawmaterial'"
              @click="windows = 'rawmaterial'"
            >
              Raw Material
            </v-chip>
            <v-spacer></v-spacer>
            <v-btn
              @click="windows = 'addrawmaterial'"
              outlined
              color="green"
              class="mb-4"
              v-if="windows == 'rawmaterial'"
              :disabled="windows === 'addrawmaterial'"
            >
              Add Raw Material
            </v-btn>
            <v-btn
              @click="deleteJobOrder"
              outlined
              color="red"
              class="mb-4"
              v-if="windows == 'details'"
            >
              Delete
            </v-btn>
            <v-btn
              v-if="
                (jobOrder.status == 'pending' || jobOrder.status == 'Pending') &&
                  windows == 'details'
              "
              @click="goToEdit"
              color="indigo"
              outlined
              class="mb-4"
            >
              Edit
            </v-btn>
            <v-btn
              v-if="
                (jobOrder.status == 'pending' || jobOrder.status == 'Pending') &&
                  windows == 'details'
              "
              @click="completeStatus"
              color="green"
              outlined
              class="mb-4"
            >
              Change Status to Completed
            </v-btn>
            <v-btn
              color="green"
              outlined
              class="mb-4"
              v-if="jobOrder.product_id != null"
              @click="generateBarcode"
            >
              Print Barcode
            </v-btn>
            <v-btn
              v-if="jobOrder.product_id != null"
              class="mb-4"
              outlined
              color="green"
              @click="generateTextFile"
            >
              Download text file
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-sheet>
    </div>
    <confirm ref="confirm"></confirm>
  </v-bottom-sheet>
</template>

<script>
import { mapState } from 'vuex';
import { mapActions } from 'vuex';
import jobordershowrawmaterial from './JobOrderShowRawMaterial';
import joborderaddrawmaterial from './JobOrderAddRawMaterial';
import confirm from '../../components/Confirm.vue';
import { unparse } from 'papaparse';
import { saveAs } from 'file-saver';

export default {
  data: function() {
    return {
      windows: 'details',
      serial: ''
    };
  },
  components: {
    jobordershowrawmaterial,
    joborderaddrawmaterial,
    confirm
  },
  props: {
    show: false,
    page: 0
  },
  beforeMount() {
    if (this.show) {
      this['JobOrder/getJobOrder']({ id: this.$route.params.id }).finally(() => {
        if (this.jobOrder.customer.name == '') {
          this.$router.push('/joborder');
        }
      });
    }
  },
  computed: {
    ...mapState({
      jobOrder(state) {
        if (typeof state.JobOrder.jobOrder.data == 'undefined') {
          return {
            customer: {
              name: ''
            },
            product_type: {
              name: ''
            },
            job_order_materials: [],
            files: '',
            category: '',
            customer_id: undefined,
            couple_name1: '',
            couple_name2: '',
            contact_number: '',
            product_type_id: '',
            size: '',
            width: '',
            thickness: '',
            weight: '',
            karat: '',
            color: '',
            no_of_diamond: '',
            couple2_size: '',
            couple2_width: '',
            couple2_thickness: '',
            couple2_weight: '',
            couple2_color: '',
            couple2_no_of_diamond: '',
            engraving: '',
            design_code: '',
            gia: '',
            price: 0,
            cogs: '',
            files: undefined,
            deposit: 0,
            balance: 0,
            weddingDate: '',
            factoryDate: '',
            orderDate: '',
            deliveryDate: '',
            delivery: '',
            rush: '',
            notes: ''
          };
        }
        return state.JobOrder.jobOrder.data;
      }
    }),
    design_code: function() {
      if (typeof this.jobOrder.product != 'undefined' && this.jobOrder.product != null) {
        return this.jobOrder.product.inventories[0].serial;
      }
      return '';
    },
    job_order_materials: function() {
      return this.jobOrder.job_order_materials;
    }
  },

  methods: {
    ...mapActions([
      'JobOrder/fetchJobOrders',
      'JobOrder/getJobOrder',
      'openBarCodePrint',
      'setBarcodes'
    ]),
    deleteJobOrder() {
      this.$refs.confirm
        .open(
          'Delete Job Order',
          'Are you sure you want to job order ID ' + this.jobOrder.id + '?',
          { color: '#f44336' }
        )
        .then(confirm => {
          axios
            .delete(`api/v1/joborder/${this.$route.params.id}`)
            .then(response => {
              this.$store.commit('SET_SNACK_BAR', {
                message: 'Job Order deleted...',
                color: 'success'
              });
              this['JobOrder/fetchJobOrders']({ page: this.page });
              this.$router.push('/joborder');
            })
            .catch(error => {
              if (error.response.status == 403) {
                this.$store.commit(
                  'SET_SNACK_BAR',
                  {
                    message: error.response.data['message'],
                    color: 'error'
                  },
                  { root: true }
                );
              } else {
                this.errorMessages = error.response.data.errors;
              }
            })
            .finally(() => {});
        });
    },
    goToEdit() {
      this.$router.push(`/joborder/${this.$route.params.id}/edit`);
    },
    completeStatus() {
      axios
        .post(`api/v1/joborder/${this.$route.params.id}/changeCompleted`)
        .then(response => {
          this.$store.commit('SET_SNACK_BAR', {
            message: 'JobOrder change to completed...',
            color: 'success'
          });
          this.errorMessages = [];
          this['JobOrder/fetchJobOrders']({ page: this.page });
          this.$router.push('/joborder');
          this.show = false;
        })
        .catch(response => {
          this.errorMessages = response.response.data.errors;
        })
        .finally(() => {});
    },
    generateBarcode() {
      axios
        .get(`api/v1/joborder/${this.$route.params.id}/getBarcode`)
        .then(response => {
          this.errorMessages = [];
          this.openBarCodePrint();
          this.setBarcodes(response.data);
        })
        .catch(response => {
          this.errorMessages = response.response.data.errors;
        })
        .finally(() => {});
    },
    generateTextFile() {
      axios
        .get(`api/v1/joborder/${this.$route.params.id}/getBarcode`)
        .then(response => {
          this.serial = [response.data];
          let barcode_data = [[this.serial[0][0], this.jobOrder.price]];
          console.log(barcode_data);
          let csv = unparse(barcode_data, { delimiter: '\t' });
          let blob = new Blob([csv], {
            type: 'application/csvcharset=utf8'
          });

          saveAs(blob, 'barcodedb.txt');
        })
        .catch(response => {})
        .finally(() => {});
    },
    is_wedding_ring() {
      return this.jobOrder.category == 'Wedding rings' || this.jobOrder.category == 'Wedding Rings';
    }
  }
};
</script>
